import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { CompanyService } from '@app/shared/services/company.service';
import { IFBColorTheme } from '@app/models/color-theme';

@Injectable({
  providedIn: 'root'
})
export class ColorThemeResource {
  constructor(
    private companyService: CompanyService,
    private http: HttpClient
  ) {}

  private get companyId(): string {
    return this.companyService.data.id;
  }

  private url(companyId?: string): string {
    return `https://${environment.API_BASE}/v1/companies/${companyId || this.companyId}`;
  }

  public get(companyId?: string) {
    return this.http.get<IFBColorTheme>(`${this.url(companyId)}/color_theme`);
  }

  public update(theme: IFBColorTheme) {
    return this.http.put(`${this.url()}/color_theme`, theme);
  }

  public delete() {
    return this.http.delete(`${this.url()}/color_theme`);
  }
}
